import { Box } from "@mui/system";
import Navbar from "./Components/Navbar/Navbar";
import Sidebar from "./Components/Sidebar/Sidebar";
import MainRoutes from "./Routes/MainRoutes";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "./Store/Common/commonStore";
import ErrorModal from "./Components/ErrorModal/ErrorModal";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

function App() {
  const token = Cookies.get("ssp_sso_token");
  const location = useLocation();
  const dispatch = useDispatch();
  const tokenErr = useSelector((state) => state.common?.tokenErr);
  const [openModal, setOpenModal] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const routes = ["/gmb", "gmb"];
  const shouldNotHaveNavbar =
    routes.includes(location.pathname) ||
    routes.includes(location?.pathname?.split("/")[1]) ||
    location?.pathname === "/slotify_list/corellia" ||
    location?.pathname === "/slotify_list/naboo" ||
    location?.pathname === "/slotify_list/alderaan" ||
    location?.pathname === "/slotify_list/kashyyyk" ||
    location?.pathname === "/slotify_list/bespin" ||
    location?.pathname === "/slotify_list/coruscant" ||
    location?.pathname === "/slotify_list/tatooine" ||
    location?.pathname === "/slotify_list/endor" ||
    location.pathname == "/cctv" ||
    location.pathname == "/cctv_download" ||
    location.pathname == "/cctv_playback";

  const checkForPlanoRoutes = () => {
    if (
      location.pathname === "/plano_portal/store" ||
      location.pathname === "/plano_portal/gallery" ||
      location.pathname === "/plano_portal/plano"
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (token) {
      dispatch(setToken(token));
    } else {
      setOpenModal(true);
    }
  }, []);

  useEffect(() => {
    if (tokenErr) {
      setOpenModal(true);
    }
  }, [tokenErr]);

  return (
    <>
      <ToastContainer
        className="toast-position"
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{ zIndex: 9999999 }}
      />
      {location?.pathname === "/slotify_list/corellia" ||
      location?.pathname === "/slotify_list/naboo" ||
      location?.pathname === "/slotify_list/alderaan" ||
      location?.pathname === "/slotify_list/kashyyyk" ||
      location?.pathname === "/slotify_list/bespin" ||
      location?.pathname === "/slotify_list/coruscant" ||
      location?.pathname === "/slotify_list/tatooine" ||
      location?.pathname === "/slotify_list/endor" ||
      location.pathname == "/cctv" ||
      location.pathname == "/cctv_download" ||
      location.pathname == "/cctv_playback" ? null : (
        <Box height={30} />
      )}
      {!shouldNotHaveNavbar && <Navbar />}
      <Box sx={{ display: "flex" }}>
        {checkForPlanoRoutes() && <Sidebar />}
        {/* <Box component="main" sx={{ flexGrow: 1, width: "100vh" }}> */}
        <Box
          component="main"
          sx={{ flexGrow: 1, width: isMobile ? "50vh" : "100vh" }}
        >
          <MainRoutes />
        </Box>
      </Box>
      <ErrorModal openModal={openModal} />
    </>
  );
}

export default App;
